import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-h-primary-50 border py-2" }
const _hoisted_2 = { class: "container mx-auto" }
const _hoisted_3 = {
  key: 0,
  class: "container mx-auto w-12/12 sm:w-10/12 lg:w-6/12 my-10"
}
const _hoisted_4 = { class: "flex justify-between items-center col-span-12" }
const _hoisted_5 = { class: "flex gap-3" }
const _hoisted_6 = { class: "my-4 col-span-12" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "my-4 col-span-12" }
const _hoisted_9 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_BreadcrumbComponent = _resolveComponent("BreadcrumbComponent")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_Loader, {
      loader: _ctx.formLoader,
      label: "Carregando...",
      loaderType: "progress",
      loaderSize: "h-96"
    }, null, 8, ["loader"]),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_BreadcrumbComponent, {
          home: _ctx.home,
          items: _ctx.items
        }, null, 8, ["home", "items"])
      ])
    ]),
    (!_ctx.formLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("form", {
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.submitObjective()), ["prevent"])),
            class: "grid grid-cols-12 items-center gap-x-3",
            autocomplete: "off"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Novo objetivo", en: "New objective" })), 1),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Button, {
                  id: "objective-cancel-btn",
                  label: _ctx.$t('labels.cancel'),
                  class: "btn-outline-bg-white p-button-sm",
                  loading: _ctx.formLoader,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmModal()))
                }, null, 8, ["label", "loading"]),
                _createVNode(_component_Button, {
                  id: "objective-save-btn",
                  label: _ctx.$t('labels.save'),
                  type: "submit",
                  class: "btn-primary p-button-sm",
                  loading: _ctx.btnLoader
                }, null, 8, ["label", "loading"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("objectives.inputs.name")), 1),
              _createVNode(_component_InputText, {
                id: "objective-save-input",
                type: "text",
                name: "name",
                modelValue: _ctx.infoData.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.infoData.name) = $event)),
                class: _normalizeClass(_ctx.v$.infoData.name.$error ? 'p-invalid' : ''),
                maxlength: 50
              }, null, 8, ["modelValue", "class"]),
              _createVNode(_component_Errors, {
                errors: _ctx.v$.infoData.name.$errors,
                actualLength: _ctx.infoData.name?.length,
                maxLength: 50
              }, null, 8, ["errors", "actualLength"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("objectives.inputs.description")), 1),
              _createVNode(_component_Textarea, {
                id: "objective-description-input",
                autoResize: true,
                rows: "10",
                cols: "30",
                modelValue: _ctx.infoData.description,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.infoData.description) = $event)),
                class: _normalizeClass(_ctx.v$.infoData.description.$error ? 'p-invalid' : ''),
                maxlength: 999
              }, null, 8, ["modelValue", "class"]),
              _createVNode(_component_Errors, {
                errors: _ctx.v$.infoData.description.$errors,
                actualLength: _ctx.infoData.description?.length,
                maxLength: 999
              }, null, 8, ["errors", "actualLength"])
            ])
          ], 32)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmDialog, { style: { width: '80vw', maxWidth: '700px' } })
  ]))
}